import { Property as GqlProperty } from '@willow/graphql-iso/src/app';
import { Property as IsoProperty } from '@willow/types-iso';

export function getNumOfActiveProperties(properties: IsoProperty[]): number;
export function getNumOfActiveProperties(properties: GqlProperty[]): number;
export function getNumOfActiveProperties(properties: (IsoProperty | GqlProperty)[]): number {
  return properties.filter((p) => !p.isReleased).length;
}
